import React, { useState, useEffect } from "react";
import CalendarHighlight from "../../../components/calendar/calendarHighlight";
import { getYear, getMonth } from "date-fns";
import "./styles.css";
import { formatDateWithDayNumber } from "../../../utils/dateUtils";

const monthsMini = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC"
];

const getCurrentYear = () => getYear(new Date());
const getCurrentMonth = () => getMonth(new Date()) + 1;

const CalendarSection = ({ orderData, onPeriodChange }) => {
  const [year, setYear] = useState(getCurrentYear());
  const [month, setMonth] = useState(getCurrentMonth());
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    onPeriodChange?.({ month, year });
  }, [month, year, onPeriodChange]);

  const extractDates = (orders) => orders.map((order) => (new Date(order.creation_date)).toISOString());

  const filterByMonthAndYear = (orders, month, year) => {
    return orders.filter((order) => {
      const date = new Date(order.creation_date);
      return date.getMonth() + 1 === month && date.getFullYear() === year;
    });
  };

  useEffect(() => {
    setFilteredOrders(filterByMonthAndYear(orderData, month, year));
  }, [month, year, orderData]);

  return (
    <div className="HContainer-order j-space-between ">
      <CalendarHighlight
        markedDates={extractDates(orderData)}
        setMonth={setMonth}
        setYear={setYear}
      />
      <div className="VContaineR w-complete mv-15">
        <div className="w-complete j-center">
          <h3 className="request-title-calendar mayus">
            Órdenes en {monthsMini[month - 1]} - {year}
          </h3>
        </div>
        <div className="orderContainer">
          <ul className="order-list">
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <li className="order-item " key={order.service_order_id}>
                  <strong>{formatDateWithDayNumber(order.creation_date) + ':  '}</strong>
                  <strong>
                    <span className="request-title-calendar mr-10">
                      {order.service_order_name}
                    </span>
                    {order.engineer_name}
                  </strong>
                  <p className="order-text">{order.activity_name}</p>
                </li>
              ))
            ) : (
              <p className="text-center">No hay órdenes en este mes.</p>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CalendarSection;
